import Vue from 'vue';
import lahi from './lahi/lahi.vue';
import store from '../common/js/vuex/store';
import lahiStore from './lahi/lahi-vuex';
if (!store.hasModule(['lahi'])) {
	store.registerModule('lahi', lahiStore);
}
Vue.component('lahi', lahi);
